import { ReactNode } from 'react';
import { DEFAULT_MAP_ID } from '../Map';

const BASE_URL = 'https://maps.googleapis.com/maps/api/staticmap';

const DEFAULT_SIZE = {
    width: 600,
    height: 200,
};

const DEFAULT_KEY = 'AIzaSyDe_QvLwfkNqtQ5v-Nn0ISVMag_N5faWVY';

interface GoogleMapProps {
    center: {
        lat: number;
        lng: number;
    };
    zoom: number;

    apiKey?: string;

    // Optional parameters
    mapId?: string;
    size?: {
        width: number;
        height: number;
    };
}

export const staticGoogleMapUrl = ({
    mapId = DEFAULT_MAP_ID,
    center,
    zoom,
    size = DEFAULT_SIZE,
    apiKey,
}: GoogleMapProps) => {
    const urlPieces = [
        `scale=2`,
        `key=${apiKey || `${DEFAULT_KEY}`}`,
        `map_id=${mapId || DEFAULT_MAP_ID}`,
        `center=${center.lat},${center.lng}`,
        `zoom=${zoom}`,
        'format=jpeg',
        `size=${size.width}x${size.height}`,
    ];

    return `${BASE_URL}?${urlPieces.join('&')}`;
};

export const StaticGoogleMap = ({
    children,
    ...props
}: GoogleMapProps & { children?: ReactNode }) => {
    if (children) {
        <div>
            <img
                src={staticGoogleMapUrl(props)}
                style={{ width: '100%', height: '100%' }}
            />
            {children}
        </div>;
    }
    return <img src={staticGoogleMapUrl(props)} />;
};
